export default {
  apiKey: process.env.FIREBASE_SECRET,
  authDomain: 'itemmanager.uk',
  databaseURL: 'https://item-manager-fdf57.firebaseio.com',
  projectId: 'item-manager-fdf57',
  storageBucket: 'item-manager-fdf57.appspot.com',
  messagingSenderId: '1080753689106'
}



// WEBPACK FOOTER //
// ./src/utils/firebase.js